<template>
    <div class="fixed z-10 overflow-y-auto top-0 w-full left-0" id="modal">
        <div class="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity"><div class="absolute inset-0 bg-gray-900 opacity-75" /></div>
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
            <div class="inline-block align-center bg-white rounded-lg text-left overflow-hidden shadow-xl xl:mt-8 lg:mt-8 md:mt-6 sm:mt-1 p-2 transform transition-all" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <div class="bg-white p-1">
                    <div class="flex flex-col items-center">
                        <div class="">
                            <img class="xl:w-60 lg:w-60 md:w-16 sm:w-16" src="../assets/star/one-star.png" alt="star">
                        </div>
                        <div class="-translate-y-14">
                            <p class="text-2xl font-bold shadow-lg shadow-gray-500 p-5 rounded-lg mt-8">ไม่สำเร็จโปรดเล่นอีกครั้ง</p>
                        </div>
                        <div class="flex justify-around gap-x-20 p-10">
                            <div class="flex flex-col items-center hover:ring-4 p-4 border rounded-lg shadow-lg shadow-gray-500" @click="resetGame()">
                                <div>
                                    <img class="xl:w-32 lg:w-32 md:w-14 sm:w-14" src="../assets/materials/reload.png" alt="reload">
                                </div>
                                <div>
                                    <p class="text-base">เล่นอีกครั้ง</p>
                                </div>
                            </div>
                            <div class="flex flex-col items-center hover:ring-4 p-4 border rounded-lg shadow-lg shadow-gray-500" @click="nextCheckPoint()">
                                <div>
                                    <img class="xl:w-32 lg:w-32 md:w-14 sm:w-14" src="../assets/materials/arrow.png" alt="arrow">
                                </div>
                                <div>
                                    <p class="text-base">ด่านต่อไป</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>           
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InCorrect",
    props: {
        resetGame: Function,
        nextCheckPoint: Function
    }
};
</script>